import { createAction } from '@reduxjs/toolkit';

export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_SANCKBAR = 'HIDE_SANCKBAR';

export const showSnackbar = createAction(SHOW_SNACKBAR, payload => ({
  payload,
}));
export const hideSnackbar = createAction(HIDE_SANCKBAR);
